import { create, setAuthorization } from "./apiService";
import { clearAuthData } from "../context/AuthActions";

interface Auth0LogoutOptions {
  logoutParams?: {
    returnTo?: string;
  };
}

type Auth0LogoutFn = (options?: Auth0LogoutOptions) => void;

export const performLogout = async (
  auth0Logout: Auth0LogoutFn,
  returnTo: string
): Promise<void> => {
  try {
    await create("/api/v2/auth/sign-out");
  } catch (error) {
    console.error("Backend sign out failed:", error);
  } finally {
    clearAuthData();
    sessionStorage.clear();
    setAuthorization(null);
    auth0Logout({
      logoutParams: {
        returnTo,
      },
    });
  }
};
